import Modal from 'react-modal';
import ReviewForm from './ReviewForm';

interface ReviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  walkId: string;
}

const ReviewModal: React.FC<ReviewModalProps> = ({ isOpen, onClose, walkId }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Submit a Review"
      style={{
        overlay: {
          zIndex: 9999,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px', // ensures breathing room on small screenszIndex: 9999,
        },
        content: {
          position: 'relative',
          inset: 'unset', // override default top/right/bottom/left
          maxWidth: '500px',
          width: '100%',
          maxHeight: '90vh',
          overflowY: 'auto',
          padding: '20px',
          borderRadius: '10px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
          backgroundColor: '#fff',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        },
      }}
    >
      <h2>Review This Walk 🐾</h2>
      <ReviewForm walkId={walkId} onReviewSubmitted={onClose} />
    </Modal>
  );
};

export default ReviewModal;
